import * as React from 'react';
import classNames from 'classnames';
import { compose } from 'recompose';
import { reduxForm } from 'redux-form';
import { InjectedFormProps } from 'redux-form';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { connect } from 'react-redux';

import IMPComponent from '../../../components/interfaces/IMPComponent';

import Button from '../../../components/Button';
import { PasswordField } from '../../../components/Form';
import { withModal } from '../../../modules/modal/withModal';
import * as userProfileActions from '../actions';

import './styles.scss';

interface IFormData {
  oldPassword?: string;
  newPassword?: string;
  newPasswordConfirmation?: string;
}

interface IConnectedProps {
  submitChangeUserPasswordForm: typeof userProfileActions.submitChangeUserPasswordForm;
}

type IChangePasswordModalProps = IMPComponent & InjectedFormProps<IFormData, {}, {}> & IConnectedProps;

const translationsScope = 'containers.UserProfile.ChangePasswordModal';

class ChangePasswordModal extends React.Component<IChangePasswordModalProps & InjectedIntlProps> {
  public render() {
    const {
      className,
      handleSubmit,
      valid,
      intl: { formatMessage },
    } = this.props;

    const cn = classNames('ChangePasswordModal', className);

    return (
      <div className={cn}>
        <form action="#" className="ChangePasswordModal-form" onSubmit={handleSubmit(this.onSubmit)}>
          <div className="ChangePasswordModal-title">
            {formatMessage({
              id: `${translationsScope}.title`,
            })}
          </div>
          <div className="ChangePasswordModal-item">
            <PasswordField
              label={formatMessage({
                id: `${translationsScope}.oldPasswordLabel`,
              })}
              name="oldPassword"
              withErrorBelow={true}
            />
          </div>
          <div className="ChangePasswordModal-item">
            <PasswordField
              label={formatMessage({
                id: `${translationsScope}.newPasswordLabel`,
              })}
              name="newPassword"
              withErrorBelow={true}
            />
          </div>
          <div className="ChangePasswordModal-item">
            <PasswordField
              label={formatMessage({
                id: `${translationsScope}.confirmNewPasswordLabel`,
              })}
              name="newPasswordConfirmation"
              withErrorBelow={true}
              matchesField="newPassword"
              matchFieldLabel={formatMessage({
                id: `${translationsScope}.newPasswordLabel`,
              })}
            />
          </div>
          <div className="ChangePasswordModal-actions">
            <Button type="submit" block={true} disabled={!valid}>
              {formatMessage({
                id: `${translationsScope}.submit`,
              })}
            </Button>
          </div>
        </form>
      </div>
    );
  }

  private onSubmit = () => {
    const {
      submitChangeUserPasswordForm,
      intl: { formatMessage },
    } = this.props;

    submitChangeUserPasswordForm(
      formatMessage({
        id: `${translationsScope}.changePasswordSuccess`,
      }),
    );
  };
}

export const CHANGE_PASSWORD_MODAL_NAME = 'userProfileChangePassword';

const enhance = compose(
  withModal({
    modalName: CHANGE_PASSWORD_MODAL_NAME,
  }),
  injectIntl,
  connect(
    null,
    userProfileActions,
  ),
  reduxForm({
    form: CHANGE_PASSWORD_MODAL_NAME,
  }),
);
export default enhance(ChangePasswordModal);



// WEBPACK FOOTER //
// ./src/containers/UserProfile/ChangePasswordModal/index.tsx